import React from 'react';

export default function FetalMovement() {
  return (
    /* eslint-disable max-len */
    <div>
      <h2>What is fetal movement tracking?</h2>
      <p>Fetal movement tracking (often known as “kick counting”)  is a way to check pregnancy health. It&#39;s done by identifying the unique pattern of your baby&#39;s movements in the third trimester to quickly recognize if there is a change.</p>
      <h2>Why might I need to do fetal movement tracking?</h2>
      <p>A change in the normal pattern or number of fetal movements may mean the baby is under stress. Please keep in mind that it&#39;s not normal for a baby to move less as you approach your due date (a common misconception is that your baby runs out of room).</p>
      <h2>What are the risks of fetal movement tracking?</h2>
      <p>Fetal movement tracking does not put you nor your baby at risk. Research has shown that identifying decreased fetal movement can help prevent complications such as stillbirth. Tracking daily will help to ensure the health of the baby and the expectant individual. Some people may believe that it can cause additional stress, but studies have shown that it reduces stress and increases bonding.</p>
      <h2>When should I start tracking my fetal movements?</h2>
      <p>
        By week 20, you will most likely start to feel your baby move in utero. However, your baby&#39;s movements will most likely only start to develop a pattern around 28 weeks.  You may start tracking earlier if you are experiencing a high-risk pregnancy. Talk to your care provider about when is the best time for you to start tracking your movements.
      </p>
      <h2>How do I track my fetal movements?</h2>
      <p>
        First you&#39;ll need to choose one of two methods to compare your data:
      </p>
      <ol>
        <li>Tracking movements over a fixed amount of time </li>
        <li>
          Tracking time it takes to reach a fixed number of movements.
        </li>
      </ol>
      <p>After several days, you will start to recognize your baby&#39;s pattern. Although there are several guidelines for fetal movements, every baby is unique. If you notice a change, talk to your care provider right away.</p>
      <p>Note: Fetuses have sleep cycles. So, while fetal movement tracking may be done at any time of day, it is best done when they are awake. They are typically most active at night or after a meal. Continuous use of this fetal movement tracker can help you identify your baby&#39;s most active times. Try to track around the same time each day. </p>
      <h2>What are the current guidelines?</h2>
      <p>Although there is no set number of “normal” movements that a baby should have, below are some guidelines currently used in different regions of the world. </p>
      <p>
        Remember: a change in your baby&#39;s pattern could be a sign of a problem, regardless of the specific number stated in the guidelines.
      </p>
      <ul>
        <li>Canada: 6+ movements within 2 hours (SOGC)</li>
        <li>U.S.: 10+ movements within 2 hours (ACOG)</li>
        <li>U.K.: A change in your normal pattern (NHS)</li>
        <li>Australia: A change in your normal pattern (ADH)</li>
      </ul>
      <h2>What happens after fetal movement tracking?</h2>
      <p>
        Call your healthcare provider right away if any of the following occur:
      </p>
      <ul>
        <li>Your baby is not moving as much as usual.</li>
        <li>It takes longer for your baby to move in the usual length of time.</li>
        <li>Your baby has stopped moving.</li>
        <li>You notice a change in the strength of your baby&#39;s movements.</li>
        <li>You are concerned for any reason about your baby&#39;s movements.</li>
      </ul>
      <p>
        Your healthcare provider will be able to perform additional tests (e.g. non-stress test, blood test, ultrasound) to ensure everything is okay. Do not hesitate to call if you have any concerns. You are not wasting anyone&#39;s time. This is to protect you and your baby!
      </p>
      <p>
        Source: Stanford Children&#39;s Health
        <br />
        <a href="https://www.stanfordchildrens.org/en/topic/default?id=fetal-movement-counting-90-P02449">Fetal Movement Counting</a>
      </p>
      <p>
        Source: Stillbirth Centre of Research Excellence
        <br />
        <a href="http://stillbirthcre.org.au/parents/safer-baby/movements-matter/">Movements Matter</a>
      </p>
      <p>
        Source: HealthLink BC
        <br />
        <a href="http://www.healthlinkbc.ca/health-topics/your-babys-movements-during-pregnancy">Your Baby&#39;s Movements During Pregnancy</a>
      </p>
    </div>
  );
}
